import React, { useRef, useState } from 'react';
import './App.css';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import Navbar from './Components/NavBar/Navbar';
import Home from './Pages/Home/Home';

function App() {
  const todayTicketRef = useRef(null);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const [showTodayBooking, setShowTodayBooking] = useState(false);

  const handleTodayTicketClick = () => {
    if (todayTicketRef.current) {
      todayTicketRef.current.scrollIntoView({ behavior: 'smooth' });
      setIsHighlighted(true);
      setShowTodayBooking(true);
      // Remove the highlight after a short delay
      setTimeout(() => {
        setIsHighlighted(false);
      }, 2000); // 2 seconds
    }
  };

  return (
    <>
      <Router>
        <Navbar onTodayTicketClick={handleTodayTicketClick} />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home
                forwardedRef={todayTicketRef}
                isHighlighted={isHighlighted}
                showTodayBooking={showTodayBooking}
              />
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
